import { type RemoteConfig } from 'firebase/remote-config';
import { useRemoteConfig } from './useRemoteConfig';
import { useLocalStorage } from './useLocalStorage';

export function useShowBuyBalancePage(config: RemoteConfig) {

  const remoteConfig = useRemoteConfig(config);
  const localStorage = useLocalStorage();

  return (
    remoteConfig.showBuyBalancePage && 
    (remoteConfig.isWithinServiceHours || localStorage.signupWithinServiceHours)
  );
}
